import { US_PHONE_CODE } from './const';

export function appendCodeToPhoneNumber(phoneNumber: string): string {
  if (phoneNumber.startsWith(US_PHONE_CODE)) {
    return phoneNumber;
  }

  return `${US_PHONE_CODE}${phoneNumber}`;
}

export function removeCodeFromPhoneNumber(phoneNumber?: string): string {
  if (!phoneNumber) return '';

  const digits = phoneNumber.replace(/\D/g, '');
  const code = US_PHONE_CODE.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith(code)) {
    return digits.slice(code.length);
  }

  return phoneNumber.replace(US_PHONE_CODE, '');
}
